import BaseReducer from "../../utilities/BaseReducer";
import IContentsState from "./models/IContentsState";

export default class ContentsReducer extends BaseReducer<IContentsState> {
    public readonly initialState: IContentsState = {};
}
